import type { AccessPermission, RichAccessControl } from "@eu.mdotm.api/smart-workspaces";
import { type MaybeArray, alwaysArray, stableEmptyArray } from "@mdotm/shadcn/legacy/utils";
import { useUserValue } from "../../user";

export function validateACLPermissions(
	userId: string,
	acl: RichAccessControl[],
	requiredPermission: MaybeArray<AccessPermission>,
): boolean {
	const requiredPermissions = alwaysArray(requiredPermission);
	const allPermissions = acl.flatMap((entry) => (entry.userId === userId ? entry.permissions : stableEmptyArray));
	return requiredPermissions.every((required) => allPermissions.includes(required));
}

export type ACLPermissionChecker = (userId: string, acl: RichAccessControl[]) => boolean;

export function useACLPermissionChecker(baseChecker: ACLPermissionChecker, acl: RichAccessControl[]): boolean {
	const user = useUserValue();
	return baseChecker(user.id, acl);
}
